import countryList from '../../../../common/countryList';

import formatter from '../../../../common/helpers/formatter';
import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';
import type { Setting } from '../../../../common/types/settings';

const coreDataForm = (advisors: Setting[]): Form<Client> => {
  const advisorOptions = advisors.map((advisor) => advisor.value);
  return {
    key: 'coreData',
    title: 'Stammdaten',
    fields: [
      {
        key: 'caseId',
        label: 'Aktenzeichen',
        fieldTypes: 'text',
      },
      {
        key: 'date',
        label: 'Datum',
        fieldTypes: 'date',
      },
      {
        key: 'name',
        label: 'Name',
        fieldTypes: 'text',
      },
      {
        key: 'maidenName',
        label: 'Geburtsname',
        fieldTypes: 'text',
      },
      {
        key: 'previousAddress',
        label: 'Bisherige Adresse',
        fieldTypes: 'text',
        xsWidth: 12,
      },
      {
        key: 'socialSecurityNumber',
        label: 'Sozialversicherungsnummer',
        fieldTypes: 'text',
        xsWidth: 12,
      },
      {
        key: 'phone',
        label: 'Telefon',
        fieldTypes: 'text',
      },
      {
        key: 'email',
        label: 'E-Mail',
        fieldTypes: 'text',
      },
      {
        key: 'birthday',
        label: 'Geburtsdatum',
        fieldTypes: 'date',
      },
      {
        key: 'placeOfBirth',
        label: 'Geburtsort',
        fieldTypes: 'text',
      },
      {
        key: 'nationality',
        label: 'Staatsangehörigkeit',
        fieldTypes: 'select',
        options: countryList,
      },
      {
        key: 'maritalStatus',
        label: 'Familienstand',
        fieldTypes: 'select',
        options: [
          {
            value: 'divorced',
            label: 'geschieden',
          },
          {
            value: 'livingApart',
            label: 'getrennt lebend',
          },
          {
            value: 'single',
            label: 'ledig',
          },
          {
            value: 'married',
            label: 'verheiratet',
          },
        ],
      },
      {
        key: 'moveInDate',
        label: 'Einzug ins Frauenhaus',
        fieldTypes: 'date',
      },
      {
        key: 'moveOutDate',
        label: 'Auszug aus dem Frauenhaus',
        fieldTypes: 'date',
        helpText: (client) => {
          const days = formatter.getDaysBetweenTwoDates(client.moveInDate, client.moveOutDate);
          return `${days} Tage`;
        },
      },
      {
        key: 'advisor',
        label: 'zuständig',
        fieldTypes: 'autocomplete',
        options: advisorOptions,
      },
      {
        key: 'roomNumber',
        label: 'Zimmmernummer',
        fieldTypes: 'text',
      },
      {
        key: 'dataPrivacy',
        label: 'Datenschutzrechtliche Einverständniserklärung erhalten',
        fieldTypes: 'checkbox',
        xsWidth: 12,
        // isVisible: (client) => (client.dataPrivacy === true ? false : true),
      },
      {
        key: 'notice',
        label: 'Notiz',
        xsWidth: 12,
        fieldTypes: 'textArea',
      },
    ],
  };
};

export default coreDataForm;
